import React, { useState } from 'react';
import { ConnectProfileView, ConnectProfileViewProps } from './ConnectProfile.view';
import { Void } from '../../../models/basic-objects';
import { ContainerListItem } from '../../actions/ListItem/ListItem.view';

export type ConnectProfileWithDropdownMenuType =
  | {
      listItems?: ContainerListItem[];
      action?: Void;
    }
  | {
      listItems: ContainerListItem[];
      action?: never;
    };

export type ConnectProfileControllerProps = ConnectProfileWithDropdownMenuType &
  Omit<ConnectProfileViewProps, 'action' | 'expanded' | 'setExpanded'> & {
    // extend your ConnectProfileViewProps
  };

export const ConnectProfileController = (props: ConnectProfileControllerProps): JSX.Element => {
  // Put All your methods and logic here
  const [expanded, setExpanded] = useState<boolean>(false);
  const setOpenHandler = (): void => {
    setExpanded(!expanded);
  };

  const action = props.action || setOpenHandler;
  const viewProps: ConnectProfileViewProps = { ...props, action, expanded, setExpanded };
  return <ConnectProfileView {...viewProps} />;
};
